export enum FrnFilingStepEnum {
    FrnType = 1,
    FrnDetail = 2,
}

/**
 * Paths for FRN Filing steps.
 */
export const FrnFilingStepPaths = {
    frnType: 'filing-type',
    frnDetail: 'detail',
} as const;

/**
 * Mapping of step paths to enum values
 */
export const FrnFilingEnumToPathMapping = {
    [FrnFilingStepPaths.frnType]: FrnFilingStepEnum.FrnType,
    [FrnFilingStepPaths.frnDetail]: FrnFilingStepEnum.FrnDetail,
} as const;
